<div class="modal-body">
  <div
    [innerHTML]="
      'reports.approve.approveReport.title'
        | translate: { id: report()?.id, kitId: kitId() }
    "
  ></div>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-clear me-2" (click)="cancel()">
    <span>{{ 'common.buttons.btnCancel' | translate }}</span>
  </button>

  <button type="button" class="btn btn-primary" (click)="onApproveReport()">
    {{ 'common.buttons.btnApprove' | translate }}
  </button>
</div>
